import crypto from 'crypto-browserify';
const Buffer = require('buffer/').Buffer;

const _devPublicKey = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyyli6RVNjdHd2VxSP4S/
W14xxGZ5jdKfX6aOncC5X4Tg4vsU8Cv206cpQPg0dNb3NHYidbsf8BJYJDh0SNVQ
+i/yfhoVSm0P3aHrjmyWgSHVX9mWVSDX5lO7v2hkRrFGn6xgnH3dsnA0d2+nD5KV
hmxBqDCDlBQOCbY3MrjzSkg8Z6q69v0G0z2hq638FYaTQmXOgKeIdEInUXeHwRlx
odCXvDEOc42IYk5+0gfEM6vg/hNRm9lCmcseReDrvy1AGysGQRJyIXA4VDRXT8Ki
YQEy3Hs7WwMf0QbDyRKRmpQC06ZS6N0a3wvqT0RGrqDUSu1TbTqQwHi30Rlx2HE+
OQIDAQAB
-----END PUBLIC KEY-----
`;

const _prodPublicKey = `
-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAp7cv3aSuMWIXRqWhk9JJ
epitSK8z9xZm9Ke+Gg2Hlz4vj3LXd9DFtBG4AaaFwBBKE2qBZ/cCFVKs528Zlrm5
uolzkhhgryeN5DqequArkD6xxJWPDA0YxEDW7j8FWqqzEV1dC7E/2vobpsRfNfya
id15FUEPdKiUeaBeSIleJ9230PIOojnAmEaOLKOBmONxCPLkGHyzUa/yJxQIJi/H
PngkJ+c29qlQ0TPEPLhLSyBAZSlITbBQjT9llJaGxrQ3gxN5mqbd04ru8EJXQOYN
uXH4bT9FBMNG2C2pP+PD7huJBL9Gw37kwWHbxkAXU831GjJfveDAvUgkVQcjW+6b
twIDAQAB
-----END PUBLIC KEY-----
`;

const _publicKeys = {
	local: _devPublicKey,
	development: _devPublicKey,
	production: _prodPublicKey
};

export function encryptCheckout(cardInformation) {
	const publicKey = _publicKeys[process.env.REACT_APP_STAGE];

	const buffer = Buffer.from(JSON.stringify(cardInformation));

	const encryptedBuffer = crypto.publicEncrypt(publicKey, buffer).toString('base64');

	return encryptedBuffer;
}
